export default __webpack_public_path__ + "static/media/equipment_active.fc450a9f.svg";